import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Typography, Card } from '@app-velocity/ui';

import { I18nResources, useI18n } from '@app-velocity/i18n';
import { TickIcon } from '@app-velocity/icons';

export type PlanProps = {
  name: I18nResources;
  price: ReactNode;
  description: I18nResources[];
  highlighted: boolean;
  action: ReactNode;
  bottom?: ReactNode;
};

const StyledPlan = styled(Card)(({ theme }) => ({
  padding: `${theme.spacing(6)} ${theme.spacing(4)}`,
  gap: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(4),
  maxWidth: theme.spacing(60),
  height: 'auto',
}));

const StyledName = styled(Typography)({
  fontSize: 18,
  fontWeight: 700,
});

const StyledDescription = styled('ul')({
  listStyleType: 'none',
  padding: 0,
  margin: 0,
  svg: {
    fill: '#1b1b1b',
  },
});

const StyledSingleDescription = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  fontWeight: 400,
  fontSize: 14,
  margin: `${theme.spacing(2)} 0`,

  svg: {
    flex: '0 0 auto',
  },
  // whiteSpace: 'nowrap'
}));

export const Plan = ({
  name,
  price,
  description,
  highlighted,
  action,
  bottom,
}: PlanProps) => {
  const { t } = useI18n();

  return (
    <StyledPlan highlighted={highlighted}>
      <StyledName>{t(name)}</StyledName>
      {price}
      {action}
      <StyledDescription>
        {description.map((text, index) => (
          <StyledSingleDescription key={index}>
            <TickIcon />
            {t(text)}
          </StyledSingleDescription>
        ))}
      </StyledDescription>
      {bottom}
    </StyledPlan>
  );
};
